/**
 * 时间格式化
 * 后端接口返回东八区时间 => 格式化后的本地时间
 * 2019-11-11T10:00:00+0800 => 2019/11/11 10:00:00
 */
import dayjs from 'dayjs';

export default function dateFormat(time, format = 'YYYY/MM/DD HH:mm:ss') {
    let res = '--';
    let tm = time;
    if (tm) {
        tm = tm.replace('+0800', '');
        res = dayjs(tm).format(format);
    }

    return res;
}
